import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ConfirmDialogData {
  title: string;
  message: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  public title: string = 'CONSTANTS.CONFIRMATION.TITLE';
  public message: string = 'CONSTANTS.CONFIRMATION.MESSAGE';
  public cancelLabel = 'CONSTANTS.BUTTONS.NO';
  public confirmLabel = 'CONSTANTS.BUTTONS.YES';

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private dialogData: ConfirmDialogData) {
  }

  ngOnInit(): void {
    if (this.dialogData) {
      if (this.dialogData.title) {
        this.title = this.dialogData.title;
      }
      if (this.dialogData.message) {
        this.message = this.dialogData.message;
      }
      if (this.dialogData.cancelLabel) {
        this.cancelLabel = this.dialogData.cancelLabel;
      }
      if (this.dialogData.confirmLabel) {
        this.confirmLabel = this.dialogData.confirmLabel;
      }
    }
  }

}
